import { Component, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarComponent implements OnInit {

  startDt: Date = new Date();
  endDt: Date= new Date();
  maxDate: Date = new Date();
  minDate = this.maxDate.setHours(23, 59, 0, 0);

  @Output() dateEvent: EventEmitter<Object> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if(JSON.parse(localStorage.getItem('reportData'))) {
      if(JSON.parse(localStorage.getItem('reportData')).startTime && JSON.parse(localStorage.getItem('reportData')).endTime) {
        let reportsData = JSON.parse(localStorage.getItem('reportData'));
        let startDate = reportsData.startTime;
        let endDate = reportsData.endTime;
        this.startDt = new Date(startDate);
        this.endDt = new Date(endDate);
      }
    } else {
      this.startDt.setHours(0, 0, 0, 0);
      this.endDt.setHours(23, 59, 0, 0);
    }
    this.sendDates();
  }

  changeEndDate() {
    if (this.startDt) {
      const getMonth = this.startDt.getMonth();
      const getYear = this.startDt.getFullYear();
      const getDate = this.startDt.getDate();
      this.endDt = new Date();
      this.endDt.setDate(getDate);
      this.endDt.setUTCMonth(getMonth);
      this.endDt.setFullYear(getYear);
      this.endDt.setHours(23, 59, 59);
      let reportData = {};
      reportData['startTime'] = this.startDt;
      reportData['endTime'] = this.endDt;
      localStorage.setItem('reportData', JSON.stringify(reportData));
      let viewReport;
      viewReport = false;
      localStorage.setItem('viewReport', JSON.stringify(viewReport));
    }
  }

  saveEndDate () {
    // let endUTC = this.endDt.toUTCString();
    // let endMilli = Date.parse(endUTC);
    let reportData = {};
    reportData['startTime'] = this.startDt;
    reportData['endTime'] = this.endDt;
    localStorage.setItem('reportData', JSON.stringify(reportData));
    let viewReport;
    viewReport = false;
    localStorage.setItem('viewReport', JSON.stringify(viewReport));
  }

  sendDates() {
    this.dateEvent.emit({startDt: this.startDt, endDt: this.endDt});
  }
}
